define((require) => {
    "use strict";

    const Class = require("shared/util/Class");

    /**
     * Provider for creating URLs related to experience edit/preview used to navigate to the passed experience.
     *
     * @class ExperienceURLProvider
     * @author avi
     */
    return Class.extend({}, {

        /**
        * Experience specific actions.
        */
        ACTION: {
            EDIT: "edit",
            PREVIEW: "preview"
        },

        TYPES: {
            EXPERIENCE: "experience",
            TEMPLATE: "template"
        },

        /**
         * Provides the experienceURL to execute an experience action (e.g preview or edit).
         * @param {String} experienceId the experience ID for which to provide the URL, never null
         * @param {string} action the action to provide. See the ACTION Object
         * @param {Number|underfined} [sceneNumber] optional; the scene number. If it's not passed, it will default to the first scene.
         * @param {String|undefined} [layerName] optional; the layer `name` property. See LayerEnum.
         * @param {string} [experienceType=this.TYPES.EXPERIENCE]
         * @returns {String} the experience URL
         */
        provide: function(experienceId, action, sceneNumber, layerName, experienceType = this.TYPES.EXPERIENCE) {
            if (!sceneNumber) {
                sceneNumber = 1;
            }

            const sceneURL = `${experienceType}/${experienceId}/${action}/${sceneNumber}`;

            return layerName ? `${sceneURL}/${layerName}` : sceneURL;
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/ExperienceURLProvider.js